import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { get, ref } from 'firebase/database';
import { database } from '../firebaseConfig';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Header = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        const userRef = ref(database, `users/${currentUser.uid}`);
        get(userRef)
          .then((snapshot) => {
            if (snapshot.exists()) {
              const userData = snapshot.val();
              setIsAdmin(userData.isAdmin || false);
              setIsStudent(userData.isStudent || false);
            } else {
              console.error('User data not found in the database.');
            }
          })
          .catch((error) => console.error('Error fetching user data', error));
      } else {
        setIsAdmin(false);
        setIsStudent(false);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
      setIsAdmin(false);
      setIsStudent(false);
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error.message);
    }
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <header>
      <nav
        ref={navbarRef}
        className="navbar navbar-dark fixed-top"
        style={{
          backgroundColor: '#000',
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <div className="d-flex align-items-center mb-2 mb-lg-0">
          <img
            src={require('./images/logo.jpg')}
            alt="Logo"
            style={{ height: '50px', marginRight: '10px' }}
          />
          <span
            style={{
              color: '#FFD700',
              fontWeight: 'bold',
              fontSize: '32px',
            }}
          >
            PRAGYESH IAS
          </span>
        </div>

        <button
          className="navbar-toggler d-lg-none"
          type="button"
          onClick={handleToggle}
          aria-expanded={isExpanded}
          style={{ color: '#fff', border: 'none' }}
        >
          <i className="bi bi-list" style={{ fontSize: '24px' }}></i>
        </button>

        <div
          className={`d-flex flex-column flex-lg-row align-items-lg-center ${isExpanded ? '' : 'd-none d-lg-flex'}`}
        >
          <Link
            to="/"
            className="btn"
            style={{
              color: '#fff',
              backgroundColor: '#007BFF',
              margin: '5px 10px',
              borderRadius: '20px',
              padding: '5px 15px',
              fontWeight: '500',
            }}
          >
            Home
          </Link>
          {user ? (
            <>
              {isAdmin && (
                <Link
                  to="/admin"
                  className="btn"
                  style={{
                    color: '#fff',
                    backgroundColor: '#007BFF',
                    margin: '5px 10px',
                    borderRadius: '20px',
                    padding: '5px 15px',
                    fontWeight: '500',
                  }}
                >
                  Admin
                </Link>
              )}
              {isStudent && (
                <Link
                  to="/student"
                  className="btn"
                  style={{
                    color: '#fff',
                    backgroundColor: '#007BFF',
                    margin: '5px 10px',
                    borderRadius: '20px',
                    padding: '5px 15px',
                    fontWeight: '500',
                  }}
                >
                  Student
                </Link>
              )}
              <button
                className="btn"
                style={{
                  color: '#fff',
                  backgroundColor: '#007BFF',
                  margin: '5px 10px',
                  borderRadius: '20px',
                  padding: '5px 15px',
                  fontWeight: '500',
                }}
                onClick={handleLogout}
              >
                Log Out
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="btn"
              style={{
                color: '#fff',
                backgroundColor: '#007BFF',
                margin: '5px 10px',
                borderRadius: '20px',
                padding: '5px 15px',
                fontWeight: '500',
              }}
            >
              Login
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
